// extracted by mini-css-extract-plugin
export default {"instruments":"ToolsPMD_instruments__qriTS","dataSettings":"ToolsPMD_dataSettings__GH3eT"};